import { createContext, useState } from "react";

const DEFAULT_BREADCRUMBS = [];

export const BreadcrumbContext = createContext(DEFAULT_BREADCRUMBS);

export const BreadcrumbContextProvider = ({ children }) => {
    const [breadcrumbs, setBreadcrumbs] = useState(DEFAULT_BREADCRUMBS);

    return (
        <BreadcrumbContext.Provider
            value={[
                breadcrumbs,
                setBreadcrumbs,
            ]}
        >
            {children}
        </BreadcrumbContext.Provider>
    );
}